export default {
  START: '@loader/START',
  STOP: '@loader/STOP',
};
